goog.provide("shadow.js.shim.module$inflation$default");
shadow.js.shim.module$inflation$default = esm_import$inflation.default;
